<template>
  <div class="whole-popover-mian">
    <div class="whole-popover-li" v-for="(item, index) in arr" :key="index">
      <div v-if="hasChildren(item)" class="popover-li-header">
        {{ item.meta && item.meta.title }}
      </div>
      <SidebarPopover
        v-if="hasChildren(item)"
        :basePath="item.path"
        :item="item"
        :activeId="activeId"
        @close="closePopover"
        :isWhole="true"
      ></SidebarPopover>
      <div
        v-else
        :class="[
          'whole-single-menu',
          'sidebar-popover-li',
          activeMenu.indexOf('-' + item.id + '-') > -1
            ? 'popover-li-active'
            : '',
        ]"
        @click.stop="popoverClick([item.path], item.children, item)"
      >
        {{ item.meta && item.meta.title }}
      </div>
    </div>
  </div>
</template>

<script>
import SidebarPopover from "@/layout/components/Sidebar/SidebarPopover";
export default {
  name: "WholePopover",
  props: {
    arr: {
      type: Array,
      required: true,
    },
    activeId: {
      type: String,
      required: "#",
    },
  },

  data() {
    return {
      companyData: {
        data: {},
      },
    };
  },
  components: {
    SidebarPopover,
  },
  computed: {
    activeMenu() {
      return this.activeId && this.activeId != "" ? this.activeId : "#";
    },
  },
  created() {
    this.companyData.data = JSON.parse(localStorage.getItem("companyInfo"));
  },
  methods: {
    hasChildren(item) {
      return !!(
        item &&
        item.children &&
        Array.isArray(item.children) &&
        item.children.length > 0
      );
    },
    popoverClick(pathArr, children, item) {
      let val = JSON.parse(JSON.stringify(item));
      if (val.oldData) {
        val = val.oldData;
      }
      if (pathArr && pathArr.length > 0) {
        localStorage.setItem(
          "Permission",
          JSON.stringify(val.childList.length ? val.childList : [val])
        );
        this.$emit("close");
        if (val.route === "/processManager/peopleOnline") {
          window.open(localStorage.getItem("companyMapUrl3"), "_blank");
          return;
        }
        this.$store.commit("add_tabs", {
          route: val.route,
          name: val.menuName,
        });
        this.$router.push(val.route);
        this.indexVal = val.id;
      }
    },
    closePopover() {
      this.$emit("close");
    },
  },
  mounted() {},
  watch: {},
};
</script>

 
<style lang="scss" scoped>
$primary: #00baff;
.whole-popover-mian {
  width: 260px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 118px);
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  box-sizing: border-box;

  .whole-popover-li {
    min-width: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border: 1px solid rgba(0, 186, 255, .18);
    border-radius: 5px;
    padding: 7px;
    background: rgba(245, 249, 253, .88);
    box-shadow: 0 2px 8px rgba(0, 45, 90, .05);

    .popover-li-header {
      display: flex;
      align-items: center;
      min-height: 24px;
      margin-bottom: 8px;
      padding: 0 0 6px 7px;
      border-bottom: 1px solid rgba(0, 186, 255, .2);
      border-left: 3px solid $primary;
      text-align: left;
      font-size: 13px;
      line-height: 18px;
      color: #1f2d3d;
      font-weight: 600;
      word-break: break-all;
    }
  }

  .whole-single-menu {
    width: 100%;
    margin: 0;
  }
}

.whole-popover-mian ::v-deep .sidebar-popover-mian {
  width: 100%;
  max-height: none;
  padding-bottom: 0;
  overflow: visible;
}

.whole-popover-mian ::v-deep .popover-ul-mian {
  width: 100%;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.whole-popover-mian ::v-deep .sidebar-popover-ul {
  display: grid;
  grid-template-columns: 1fr;
  gap: 7px;
  align-items: stretch;
}

.whole-popover-mian ::v-deep .sidebar-popover-title {
  grid-column: 1 / -1;
  width: auto;
  height: auto;
  min-height: 20px;
  margin: 0 !important;
  padding-left: 7px;
  border-left: 3px solid rgba(0, 186, 255, .75);
  font-size: 12px;
  line-height: 18px;
  color: #606266;
  text-align: left;
}

.sidebar-popover-li,
.whole-popover-mian ::v-deep .sidebar-popover-li {
  cursor: pointer;
  width: auto;
  min-height: 30px;
  margin: 0;
  padding: 6px 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f7fb;
  border: 1px solid #dbe8f3;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px !important;
  color: #313131;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.whole-popover-mian ::v-deep .sidebar-popover-li > .el-submenu__title {
  width: 100%;
  height: auto !important;
  min-height: 18px;
  padding: 0 !important;
  line-height: 18px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none !important;
}

.whole-popover-mian ::v-deep .sidebar-popover-li > .el-submenu__title > span {
  display: block;
  max-width: calc(100% - 16px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 18px !important;
  color: #313131;
}

.whole-popover-mian ::v-deep .sidebar-popover-li > .el-submenu__title > .el-submenu__icon-arrow {
  position: static !important;
  margin: 0 0 0 4px !important;
  color: #606266;
}

.sidebar-popover-li:hover,
.whole-popover-mian ::v-deep .sidebar-popover-li:hover {
  color: $primary;
  border-color: rgba(0, 186, 255, .7);
  background: #ecf9ff;
}

.popover-li-active,
.whole-popover-mian ::v-deep .popover-li-active {
  background: $primary;
  border-color: $primary;
  color: #fff;
}

.whole-popover-mian ::v-deep .popover-li-active > .el-submenu__title > span,
.whole-popover-mian ::v-deep .popover-li-active > .el-submenu__title > .el-submenu__icon-arrow {
  color: #fff;
}
</style>
